export function computeBodyStats(body: string) {
  const text = body.replace(/!\[.*?\]\(.*?\)/g, '').replace(/\[([^\]]*)\]\(.*?\)/g, '$1').replace(/[#*_~`>|]/g, '').trim()
  const words = text.split(/\s+/).filter(Boolean).length
  const paragraphs = body.split(/\n\s*\n/).filter((p) => p.trim().length > 0).length
  const sentences = text.split(/[.!?]+/).filter((s) => s.trim().length > 0).length
  const readingTimeMin = Math.max(1, Math.round(words / 230))
  const images = (body.match(/!\[.*?\]\(.*?\)/g) ?? []).length
  const headings = (body.match(/^#{1,6}\s/gm) ?? []).length
  return { words, paragraphs, sentences, readingTimeMin, images, headings }
}
